export const formatAmount = (amount = '0') => {
  const dotIndex = amount.toString().indexOf('.')
  const fixed = amount.toString().substring(0, dotIndex + 3);

  const formatedAmount = new Intl.NumberFormat(
    'en-US',
    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
  ).format(parseFloat(fixed))

  return formatedAmount
}